export const SUPER_ADMIN_NAV = [
  { key: "dashboard", label: "Dashboard", to: "/super-admin", icon: "home" },
  {
    key: "users",
    label: "User Management",
    icon: "users",
    children: [
      { label: "All Users", to: "/super-admin/users" },
      { label: "Employees", to: "/super-admin/users/employees" },
      { label: "Job Seekers", to: "/super-admin/users/job-seekers" },
      { label: "Employers", to: "/super-admin/users/employers" },
      { label: "Recruiters", to: "/super-admin/users/recruiters" },
    ],
  },
  {
    key: "jobs",
    label: "Jobs & Recruitment",
    icon: "briefcase",
    children: [
      { label: "All Jobs", to: "/super-admin/jobs" },
      { label: "Recruiter Jobs", to: "/super-admin/jobs/recruiter" },
      { label: "Applications", to: "/super-admin/jobs/applications" },
      { label: "Interviews", to: "/super-admin/jobs/interviews" },
      { label: "Job Syndication", to: "/super-admin/jobs/syndication" },
    ],
  },
  {
    key: "ratings",
    label: "Ratings & Reviews",
    icon: "star",
    children: [
      { label: "Employee Ratings", to: "/super-admin/ratings/employees" },
      { label: "Employer Ratings", to: "/super-admin/ratings/employers" },
      { label: "Moderation", to: "/super-admin/ratings/moderation" },
    ],
  },
  {
    key: "verification",
    label: "Verification",
    icon: "check",
    children: [
      { label: "Requests", to: "/super-admin/verification/requests" },
      { label: "Pending", to: "/super-admin/verification/pending" },
      { label: "Verified", to: "/super-admin/verification/verified" },
      { label: "Rejected", to: "/super-admin/verification/rejected" },
    ],
  },
  {
    key: "compliance",
    label: "Compliance",
    icon: "shield",
    children: [
      { label: "DPDP Overview", to: "/super-admin/compliance" },
      { label: "Consent Records", to: "/super-admin/compliance/consent" },
      { label: "Erasure Requests", to: "/super-admin/compliance/erasure" },
    ],
  },
  {
    key: "analytics",
    label: "Trust & Analytics",
    icon: "chart",
    children: [
      { label: "Employee Trust", to: "/super-admin/analytics/employee-trust" },
      { label: "Employer Trust", to: "/super-admin/analytics/employer-trust" },
      { label: "Platform Analytics", to: "/super-admin/analytics/platform" },
    ],
  },
  {
    key: "integrations",
    label: "Integrations",
    icon: "link",
    children: [
      { label: "LinkedIn", to: "/super-admin/integrations/linkedin" },
      { label: "Indeed", to: "/super-admin/integrations/indeed" },
      { label: "Google CSE", to: "/super-admin/integrations/google" },
      { label: "SignCare", to: "/super-admin/integrations/signcare" },
      { label: "Gemini AI", to: "/super-admin/integrations/ai" },
      { label: "Integration Health", to: "/super-admin/integrations/health" },
    ],
  },
  {
    key: "audit",
    label: "Audit & Security",
    icon: "search",
    children: [
      { label: "Audit Log", to: "/super-admin/audit" },
      { label: "Admin Activity", to: "/super-admin/security/admin-activity" },
      { label: "Login Activity", to: "/super-admin/security/logins" },
      { label: "Security Events", to: "/super-admin/security/events" },
    ],
  },
  {
    key: "system",
    label: "System",
    icon: "gear",
    children: [
      { label: "System Health", to: "/super-admin/system" },
      { label: "Database Health", to: "/super-admin/system/database" },
      { label: "API Health", to: "/super-admin/system/api" },
      { label: "Environment Status", to: "/super-admin/system/environment" },
    ],
  },
];

export const SUPER_ADMIN_ACCOUNT_NAV = {
  key: "account",
  label: "Super Admin",
  icon: "user",
  children: [
    { label: "My Profile", to: "/super-admin/profile" },
    { label: "Security", to: "/super-admin/profile/security" },
    { label: "Logout", to: "__logout__" },
  ],
};

export function isNavActive(pathname, to) {
  if (!to || to === "__logout__") return false;
  const path = String(pathname || "").replace(/\/$/, "") || "/";
  const target = String(to).replace(/\/$/, "") || "/";
  return path === target;
}

export function isGroupActive(pathname, item) {
  if (item.to) return isNavActive(pathname, item.to);
  return (item.children || []).some((child) => isNavActive(pathname, child.to));
}
